
import { StdResponse, bimAxios } from "@/config/axios"
import { RsProjectGlobalDataBox } from "@/commons/interface/project-device/project-data-box";

export function getProjectDataBoxes(projectUuid: string, type: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/project-global-data-boxes`, {
        params: {
            ...params,
            type: type,
        }
    })
}

export function createProjectGDataBoxes(data: RsProjectGlobalDataBox[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/project-global-data-boxes`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteProjectGDataBox(projectUuid: string, globalDataBoxId: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/project-global-data-boxes/delete`, {
        params: {
            ...params,
            projectUuid: projectUuid,
            globalDataBoxId: globalDataBoxId,
        }
    })
}   